export const SquareIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="31"
      height="25"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.55487 24.4575C1.86487 24.4575 1.26663 24.2041 0.760125 23.6974C0.253375 23.1909 0 22.5926 0 21.9026V2.56387C0 1.87137 0.253375 1.271 0.760125 0.762749C1.26663 0.254249 1.86487 0 2.55487 0H27.8936C28.5861 0 29.1865 0.254249 29.6947 0.762749C30.2032 1.271 30.4575 1.87137 30.4575 2.56387V21.9026C30.4575 22.5926 30.2032 23.1909 29.6947 23.6974C29.1865 24.2041 28.5861 24.4575 27.8936 24.4575H2.55487ZM2.55487 21.9026H27.8936V2.56387H2.55487V21.9026Z"
        fill="currentColor"
      />
    </svg>
  );
};
